// src/feathers-client.js
/* eslint-disable */
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import io from 'socket.io-client';
import { iff, discard } from 'feathers-hooks-common';
import feathersVuex from 'feathers-vuex';

const socket = io(process.env.VUE_APP_FEATHERS_SERVER_API, {
  transports: ['websocket'],
  reconnectionDelay: 1000,
  reconnectionDelayMax: 15000,
  timeout: 120000
});

// En tu feathers-client.js
socket.on('connect_error', (error) => {
  console.error('Connection Error:', error);
  // Implementar lógica de retry
});

socket.on('disconnect', (reason) => {
  if (reason === 'io server disconnect') {
    socket.connect();
  }
});

const feathersClient = feathers()
  .configure(socketio(socket, { timeout: 240000 }))
  .configure(auth({ storage: window.localStorage }))
  .hooks({
    before: {
      all: [
        iff(
          (context) => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp')
        ),
      ],
    },
  });

export default feathersClient;

// Setting up feathers-vuex
const { makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex } =
  feathersVuex(feathersClient, {
    serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
    idField: '_id', // Must match the id field in your database table/collection
    whitelist: ['$regex', '$options'],
  });

export { makeAuthPlugin, makeServicePlugin, BaseModel, models, FeathersVuex };
